export const routes = {
  login: '/login',
  tasks: '/tasks',
  transfer: '/transfer',
  system: '/system',
} as const
